import { initConstructorCards } from "./add_to_set";
export { default as UserSetConstructorApp } from "./UserSetConstructorApp.vue";
/**
 * Подготовка страницы конструктора сетов: подключает кнопки «В сет» и возвращает параметры для блока черновика
 */
export function initSetConstructor(setDraftData) {
    initConstructorCards();
    return {
        setDraftData: setDraftData,
        setEditMode: consumeSetEditMode(),
    };
}
function consumeSetEditMode() {
    var url = new URL(window.location.href);
    if (!url.searchParams.has('edit')) {
        return false;
    }
    url.searchParams.delete('edit');
    window.history.replaceState({}, '', url.pathname + url.search);
    return true;
}
